$(document).ready(function() {
	if (!localStorage.cookies && localStorage.cookies != "false") {
		$(".cookie-box").fadeIn();
	} else {
		$(".cookie-box").css("display", "none");
		if (localStorage.cookies == "true") {
			dataLayer.push({ event: "cookieConsentGiven" });
		}
	}

	$(".privacy").click(function() {
		if (
			$(this)
				.children(".checkbox")
				.hasClass("tech-cookies")
		) {
			return; // non si può deselezionare i tech cookies
		}
		if (
			$(this)
				.children(".checkbox")
				.hasClass("active")
		) {
			$(this)
				.children(".checkbox")
				.removeClass("active");
		} else {
			$(this)
				.children(".checkbox")
				.addClass("active");
		}
	});

	$(".cookie-btn").on("click tap", function() {
		var check = false;
		$(".cookie-box .third-party-cookies").each(function() {
			if ($(this).hasClass("active")) {
				check = true;
			}
		});
		if (check) {
			console.log("check");
			$(".cookie-box").fadeOut();
			localStorage.cookies = true;
			dataLayer.push({ event: "cookieConsentGiven" });
		} else {
			$(".cookie-box").fadeOut();
			localStorage.cookies = false;
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_cookies.js
// module id = 8
// module chunks = 0